import BrandMark from "./BrandMark";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t-2 border-[#0A0A0A] bg-[#0A0A0A] text-[#FDFBF7] mt-10 sm:mt-24">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-6 sm:py-12">
        <div>
          <BrandMark size="lg" inverse />
          <p className="mt-3 text-sm opacity-80 max-w-xs">Platform clipping #1 buat creator Indonesia. Posting konten, langsung dapet cuan.</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-3 sm:py-4 text-center text-xs opacity-60">© {new Date().getFullYear()} buzzer klip Indonesia. Bikin viral, dapet cuan.</div>
    </footer>
  );
}
